angular.
module("dx.webapp.printing").
directive("dxPrintBlankPage", function dxPrintBlankPage() {
	"use strict";

	return {
		scope: {
			blankPage: "=?",
			noPageBreak: "=?",
			lastPage: "=?",
		},
		templateUrl: "tmpl/printing/print-blank-page-directive.html",
		controller: angular.noop,
		controllerAs: "vm",
		bindToController: true,
	};
});
